/**
 * Visible-column key helpers.
 *
 * Persistence has been moved to backend `user_preferences` (page_path='datatable',
 * key='column_visibility'). The functions below stay as the sync API surface
 * for legacy callers — `load` returns the default key set (caller's hook then
 * syncs from the RTK Query result), `save` is a no-op because the consumer
 * hooks now dispatch the mutation directly.
 */

export function loadVisibleColumnKeys(_storageKey: string, allKeys: string[]): string[] {
  return [...allKeys]
}

export function saveVisibleColumnKeys(_storageKey: string, _keys: string[]): void {
  // no-op — backend persistence wired through userColumnVisibilityApi
}

export function normalizeColumnKeys(keys: unknown[], allKeys: string[]): string[] {
  const allowed = new Set(allKeys)
  const seen = new Set<string>()
  const next: string[] = []
  for (const key of keys) {
    if (typeof key !== 'string' || !allowed.has(key) || seen.has(key)) continue
    seen.add(key)
    next.push(key)
  }
  return next
}
